import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  const whatsappNumber = '34667459830';
  const whatsappMessage = encodeURIComponent('Hola, me gustaría obtener más información sobre sus armarios a medida.');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black">
      {/* Navigation */}
      <nav className="bg-black/95 backdrop-blur-md border-b border-amber-500/20">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-2">
            <img src="https://static.readdy.ai/image/5ec0a551afa550ea327b68ffd2fc4f5a/5325238bb7e02f6b3dd25e9784834fa4.png" alt="Benno Armarios de Diseño" className="h-16 w-auto" />
          </Link>
          <Link to="/" className="px-6 py-2.5 text-base font-semibold transition-all duration-300 text-white hover:text-amber-400 whitespace-nowrap cursor-pointer">
            <i className="ri-arrow-left-line mr-2"></i>Volver al inicio
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">Política de Privacidad</h1>
          <div className="w-16 h-0.5 bg-gradient-to-r from-amber-500 to-amber-600 mb-12"></div>

          <div className="prose prose-invert max-w-none space-y-8 text-gray-400">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Responsable del tratamiento</h2>
              <p>
                <strong className="text-amber-500">ÁLJURSON SL – Armarios Benno</strong><br />
                CIF: [CIF de la empresa]<br />
                Dirección: Calle Escayolistas 13, 28891 Velilla de San Antonio, Madrid<br />
                Teléfono: 91 791 933<br />
                Email: info@armariosbenno.com
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. Datos que recopilamos</h2>
              <p>En Armarios Benno recopilamos los siguientes datos personales a través de nuestro formulario de contacto:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Nombre completo</li>
                <li>Dirección de correo electrónico</li>
                <li>Número de teléfono (opcional)</li>
                <li>Mensaje o consulta</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Finalidad del tratamiento</h2>
              <p>Los datos personales que nos facilites serán tratados con las siguientes finalidades:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Gestionar y responder a tus consultas sobre nuestros productos y servicios de armarios a medida</li>
                <li>Remitirte al distribuidor más cercano a tu ubicación</li>
                <li>Elaborar presupuestos personalizados</li>
                <li>Enviarte información comercial sobre nuestros productos, siempre que hayas dado tu consentimiento</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Legitimación</h2>
              <p>La base legal para el tratamiento de tus datos es:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>El consentimiento del interesado al enviar el formulario de contacto</li>
                <li>El interés legítimo de Armarios Benno para gestionar las relaciones comerciales</li>
                <li>La ejecución de un contrato o medidas precontractuales</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Conservación de datos</h2>
              <p>
                Tus datos personales serán conservados mientras exista una relación comercial con nosotros o durante el tiempo necesario para cumplir con las obligaciones legales. Una vez finalizada la relación, los datos serán bloqueados durante los plazos de prescripción legal.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Destinatarios</h2>
              <p>
                Tus datos podrán ser comunicados a nuestros distribuidores autorizados para poder atender tu solicitud de presupuesto o información. No se realizarán transferencias internacionales de datos.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Derechos del usuario</h2>
              <p>Puedes ejercer los siguientes derechos:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-white">Acceso:</strong> Conocer qué datos personales tenemos sobre ti</li>
                <li><strong className="text-white">Rectificación:</strong> Modificar datos inexactos o incompletos</li>
                <li><strong className="text-white">Supresión:</strong> Solicitar la eliminación de tus datos</li>
                <li><strong className="text-white">Oposición:</strong> Oponerte al tratamiento de tus datos</li>
                <li><strong className="text-white">Limitación:</strong> Solicitar la limitación del tratamiento</li>
                <li><strong className="text-white">Portabilidad:</strong> Recibir tus datos en formato estructurado</li>
              </ul>
              <p className="mt-4">
                Para ejercer estos derechos, puedes contactarnos en <span className="text-amber-500">info@armariosbenno.com</span> o en nuestra dirección postal, adjuntando copia de tu DNI.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Seguridad</h2>
              <p>
                En Armarios Benno hemos adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad de tus datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">9. Reclamaciones</h2>
              <p>
                Si consideras que el tratamiento de tus datos no se ajusta a la normativa vigente, puedes presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD) en <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-amber-500 hover:underline">www.aepd.es</a>.
              </p>
            </section>

            <p className="text-sm text-gray-600 mt-12">Última actualización: Enero 2025</p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-6 border-t border-amber-500/20 bg-black">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-xs text-gray-600">© 2025 Armarios Benno. Todos los derechos reservados.</p>
          <a className="text-xs text-gray-600 hover:text-amber-500 transition-colors cursor-pointer mt-2 inline-block" href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer">
            Realizado por grupo Globaltis
          </a>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a
        href={`https://wa.me/34667459830?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300 cursor-pointer group"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
        <span className="absolute right-full mr-3 px-3 py-2 bg-white text-gray-800 text-sm font-medium rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
          ¿Te ayudamos?
        </span>
      </a>
    </div>
  );
};

export default PrivacyPolicy;
